import { render, staticRenderFns } from "./Game_Dashboard.vue?vue&type=template&id=183bf67f&scoped=true&"
import script from "./Game_Dashboard.vue?vue&type=script&lang=js&"
export * from "./Game_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Game_Dashboard.vue?vue&type=style&index=0&id=183bf67f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183bf67f",
  null
  
)

export default component.exports